// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Utils from "./utils.bs.js";
import * as Belt_Id from "bs-platform/lib/es6/belt_Id.js";
import * as Belt_Map from "bs-platform/lib/es6/belt_Map.js";
import * as Belt_Set from "bs-platform/lib/es6/belt_Set.js";
import * as Belt_List from "bs-platform/lib/es6/belt_List.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_primitive from "bs-platform/lib/es6/caml_primitive.js";

function cmp(param, param$1) {
  var c = Caml_primitive.caml_int_compare(param.x, param$1.x);
  if (c !== 0) {
    return c;
  } else {
    return Caml_primitive.caml_int_compare(param.y, param$1.y);
  }
}

var FieldsComparator = Belt_Id.MakeComparable({
      cmp: cmp
    });

var empty = Belt_Map.make(FieldsComparator);

var empty$1 = Belt_Set.make(FieldsComparator);

var neighbourDiff = Belt_List.keep(Utils.cartesian({
          hd: -1,
          tl: {
            hd: 0,
            tl: {
              hd: 1,
              tl: /* [] */0
            }
          }
        }, {
          hd: -1,
          tl: {
            hd: 0,
            tl: {
              hd: 1,
              tl: /* [] */0
            }
          }
        }), (function (param) {
        if (param[0] !== 0) {
          return true;
        } else {
          return param[1] !== 0;
        }
      }));

if (Belt_List.length(neighbourDiff) !== 8) {
  Pervasives.failwith("nighbourDiff should contain exactly 8 items");
}

function gameWidthSelector(state) {
  return state.width;
}

function gameHeightSelector(state) {
  return state.height;
}

function fieldNeighboursSelector(state, field) {
  var y = field.y;
  var x = field.x;
  var height = state.height;
  var width = state.width;
  return Belt_List.keep(Belt_List.map(neighbourDiff, (function (param) {
                    return {
                            x: x + param[0] | 0,
                            y: y + param[1] | 0
                          };
                  })), (function (param) {
                var y = param.y;
                var x = param.x;
                if (x >= 0 && x < width && y >= 0) {
                  return y < height;
                } else {
                  return false;
                }
              }));
}

function fieldsSelector(state) {
  return Belt_Map.toList(state.fields);
}

function fieldStateSelector(state, field) {
  return Belt_Map.getExn(state.fields, field);
}

function adjacentMinesCountSelector(state, field) {
  return Belt_List.length(Belt_List.keep(Belt_List.map(fieldNeighboursSelector(state, field), (function (neighbour) {
                        return Belt_Map.getExn(state.fields, neighbour);
                      })), (function (param) {
                    return param.contents === /* Mine */0;
                  })));
}

function minesCountSelector(state) {
  return Belt_Map.size(Belt_Map.keep(state.fields, (function (param, param$1) {
                    return param$1.contents === /* Mine */0;
                  })));
}

function markedCountSelector(state) {
  return Belt_Map.size(Belt_Map.keep(state.fields, (function (param, param$1) {
                    return param$1.visibility === /* Marked */2;
                  })));
}

function revealedCountSelector(state) {
  return Belt_Map.size(Belt_Map.keep(state.fields, (function (param, param$1) {
                    return param$1.visibility === /* Revealed */1;
                  })));
}

function remainingMinesCountSelector(state) {
  var mines = minesCountSelector(state);
  var marked = markedCountSelector(state);
  return mines - marked | 0;
}

function gameStatusSelector(state) {
  var fields = state.fields;
  var exploded = Belt_Map.some(fields, (function (param, fieldState) {
          if (fieldState.contents) {
            return false;
          } else {
            return fieldState.visibility === 1;
          }
        }));
  var safeRemaining = Belt_Map.some(fields, (function (param, fieldState) {
          if (fieldState.contents) {
            return fieldState.visibility === 0;
          } else {
            return false;
          }
        }));
  if (exploded) {
    return /* Lost */2;
  } else if (safeRemaining) {
    return /* Playing */0;
  } else {
    return /* Won */1;
  }
}

function makeStateWithFieldsState(width, height, fieldsWithState) {
  var add2 = function (map, param) {
    return Belt_Map.set(map, param[0], param[1]);
  };
  var fieldsWithStateMap = Belt_List.reduce(fieldsWithState, empty, add2);
  if (Belt_Map.size(fieldsWithStateMap) !== Math.imul(width, height)) {
    throw {
          RE_EXN_ID: "Assert_failure",
          _1: [
            "minesweeper.res",
            138,
            2
          ],
          Error: new Error()
        };
  }
  return {
          width: width,
          height: height,
          fields: fieldsWithStateMap
        };
}

function initializeState(width, height, mines) {
  var xs = Utils.range(0, width);
  var ys = Utils.range(0, height);
  var fields = Belt_List.map(Utils.cartesian(xs, ys), (function (param) {
          return {
                  x: param[0],
                  y: param[1]
                };
        }));
  if (Belt_List.length(fields) <= mines) {
    Pervasives.failwith("Too many mines for the board");
  }
  var input = Utils.take(mines, Utils.shuffle(fields));
  var minedFields = Belt_Set.mergeMany(empty$1, Belt_List.toArray(input));
  var makeFieldWithContents = function (field) {
    var contents = Belt_Set.has(minedFields, field) ? /* Mine */0 : /* Safe */1;
    return [
            field,
            contents
          ];
  };
  var fieldsWithContents = Belt_List.map(fields, makeFieldWithContents);
  var fieldsWithState = Belt_List.map(fieldsWithContents, (function (param) {
          return [
                  param[0],
                  {
                    contents: param[1],
                    visibility: /* Hidden */0
                  }
                ];
        }));
  return makeStateWithFieldsState(width, height, fieldsWithState);
}

function reinitializeStateWithSafeField(_state, width, height, mines, safeField) {
  while(true) {
    var state = _state;
    var match = Belt_Map.getExn(state.fields, safeField);
    if (match.contents) {
      return state;
    }
    var newState = initializeState(width, height, mines);
    _state = newState;
    continue ;
  };
}

function accumulateFieldsToReveal(state, field, acc) {
  var match = Belt_Map.getExn(state.fields, field);
  var mines = adjacentMinesCountSelector(state, field);
  var accWithFieldRevealed = Belt_Set.add(acc, field);
  if (mines !== 0) {
    return accWithFieldRevealed;
  }
  if (!match.contents) {
    return accWithFieldRevealed;
  }
  var visitNeighbour = function (acc, neighbour) {
    if (Belt_Set.has(acc, neighbour)) {
      return acc;
    } else {
      return accumulateFieldsToReveal(state, neighbour, acc);
    }
  };
  return Belt_List.reduce(fieldNeighboursSelector(state, field), accWithFieldRevealed, visitNeighbour);
}

function revealFields(state, toReveal) {
  return Belt_Map.mapWithKey(state.fields, (function (field, fieldState) {
                var shouldReveal = Belt_Set.has(toReveal, field);
                if (shouldReveal) {
                  return {
                          contents: fieldState.contents,
                          visibility: /* Revealed */1
                        };
                } else {
                  return fieldState;
                }
              }));
}

function update(action, state) {
  switch (action.TAG | 0) {
    case /* Init */0 :
        return action._0;
    case /* Reveal */1 :
        var field = action._0;
        if (gameStatusSelector(state) !== /* Playing */0) {
          return state;
        }
        var firstReveal = revealedCountSelector(state) === 0;
        var state$1;
        if (firstReveal) {
          var mines = minesCountSelector(state);
          state$1 = reinitializeStateWithSafeField(state, state.width, state.height, mines, field);
        } else {
          state$1 = state;
        }
        var fieldState = Belt_Map.getExn(state$1.fields, field);
        if (fieldState.visibility !== 1) {
          var toReveal = accumulateFieldsToReveal(state$1, field, empty$1);
          var fields = revealFields(state$1, toReveal);
          return {
                  width: state$1.width,
                  height: state$1.height,
                  fields: fields
                };
        }
        var neighbours = fieldNeighboursSelector(state$1, field);
        var match = Belt_List.partition(neighbours, (function (neighbour) {
                var match = Belt_Map.getExn(state$1.fields, neighbour);
                return match.visibility >= 2;
              }));
        var mines$1 = adjacentMinesCountSelector(state$1, field);
        if (Belt_List.length(match[0]) !== mines$1) {
          return state$1;
        }
        var toReveal$1 = Belt_List.reduce(Belt_List.map(match[1], (function (param) {
                    return accumulateFieldsToReveal(state$1, param, empty$1);
                  })), empty$1, Belt_Set.union);
        var fields$1 = revealFields(state$1, toReveal$1);
        return {
                width: state$1.width,
                height: state$1.height,
                fields: fields$1
              };
    case /* ToggleMarker */2 :
        var field$1 = action._0;
        if (gameStatusSelector(state) !== /* Playing */0) {
          return state;
        }
        var fieldState$1 = Belt_Map.getExn(state.fields, field$1);
        var newFieldState;
        switch (fieldState$1.visibility) {
          case /* Hidden */0 :
              newFieldState = {
                contents: fieldState$1.contents,
                visibility: /* Marked */2
              };
              break;
          case /* Revealed */1 :
              newFieldState = undefined;
              break;
          case /* Marked */2 :
              newFieldState = {
                contents: fieldState$1.contents,
                visibility: /* Hidden */0
              };
              break;
          
        }
        if (newFieldState === undefined) {
          return state;
        }
        var fields$2 = Belt_Map.set(state.fields, field$1, newFieldState);
        return {
                width: state.width,
                height: state.height,
                fields: fields$2
              };
    
  }
}

export {
  initializeState ,
  makeStateWithFieldsState ,
  gameWidthSelector ,
  gameHeightSelector ,
  gameStatusSelector ,
  fieldsSelector ,
  fieldStateSelector ,
  adjacentMinesCountSelector ,
  remainingMinesCountSelector ,
  update ,
  
}
/* FieldsComparator Not a pure module */
